<template>
  <div>
    <div class="banner">
      <img :src="banner" v-if="clientWidth > 768" alt="" />
      <img :src="banner_m" v-if="clientWidth <= 768" alt="" />
    </div>

    <div class="module module1">
      <div class="wrap">
        <div class="per_box1">
          <div class="per_header">
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_person.png"
              alt=""
            />
            <span>{{ islogin ? userInfo.Name : "暂未登录" }}</span>
            <span
              class="goout"
              v-if="islogin"
              @click="goOut"
              v-ga="{
                event: 'trk',
                ec: 'mypoints',
                ea: 'loginmypoints',
                el: 'logout',
              }"
              >退出登录</span
            >
          </div>
          <div class="per_content">
            <div class="per_content_title1 fx1">
              <img
                src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_circle.png"
                alt=""
              />
              <span>我的积分</span>
            </div>
            <div class="per_content_title2 fx1">
              <span>累计总积分：</span>
              <span>{{ islogin ? pointAll.Integral : "0" }}</span>
              <img
                src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_coin.png"
                alt=""
              />
            </div>
            <div class="per_content_title3 fx8" v-if="!islogin">
              <img
                src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_none.png"
                alt=""
              />
              <p>
                您还没有积分哦~请立即<span
                  @click="toLogin"
                  v-ga="{
                    event: 'trk',
                    ec: 'pclogin',
                    ea: 'unlogmypoints',
                    el: 'login',
                  }"
                  >注册登录</span
                >，
              </p>
              <p>参与有奖互动~</p>
            </div>
            <!-- 已登录 -->
            <div class="p_two_two_table" v-else>
              <div class="p_two_two_table_tr1">
                <div>互动方式</div>
                <div>获得积分</div>
              </div>
              <div class="p_two_two_table_tr_num num1">
                <div>注册会员</div>
                <div id="zchy">{{ pointAll.Register }}积分</div>
              </div>
              <div class="p_two_two_table_tr_num num2">
                <div>每日登录</div>
                <div id="mrll">{{ pointAll.Sign }}积分</div>
              </div>
              <div class="p_two_two_table_tr_num num1">
                <div>观看直播</div>
                <div id="mrll">{{ pointAll.WatchLive }}积分</div>
              </div>
              <div class="p_two_two_table_tr_num num2">
                <div
                  v-html="clientWidth > 750 ? '直播小问答' : '直播<br>小问答'"
                ></div>
                <div id="mrll">{{ pointAll.ClassQuestion }}积分</div>
              </div>
              <div class="p_two_two_table_tr_num num1">
                <div>有奖调研</div>
                <!-- <div class="feedbackinto">敬请期待</div> -->
                <div>
                  <span id="yjdy" v-if="pointAll.IsExamination"
                    >{{ pointAll.Questionnaire }}积分</span
                  >
                  <span v-else
                    >参与<span id="djclick" @click="toSurvey">有奖调研</span>
                    即可获取</span
                  >
                </div>
              </div>
              <div class="p_two_two_table_tr_num num2" id="table-border">
                <div
                  v-html="
                    clientWidth > 750 ? '访问行业云展厅' : '访问<br>行业云展厅'
                  "
                ></div>
                <div class="liveTopic">{{ pointAll.VisitCloud }}积分</div>
                <!-- <div><span id="yjdy">还未参加，</span><span id="djclick" onclick="djclicka(this)">立即参与</span></div> -->
              </div>
              <div class="p_two_two_table_tr_num num1">
                <div
                  v-html="
                    clientWidth > 750 ? '新品展示小问答' : '新品展示<br>小问答'
                  "
                ></div>
                <div v-if="pointAll.NewProQuestion == 0">
                  未获得积分，<span
                    id="djclick"
                    @click="toExhibition"
                    v-ga="{
                      event: 'trk',
                      ec: 'pclogin',
                      ea: 'loginmypoints',
                      el: 'answer',
                    }"
                    >立即答题</span
                  >
                </div>
                <div v-else>{{ pointAll.NewProQuestion }}积分</div>
                <!-- <div>请关注施耐德电气官方公众号抽奖通知</div> -->
              </div>
              <div class="p_two_two_table_tr_num num2">
                <div>下载文档</div>
                <div id="xzwd">{{ pointAll.Dowlond }}积分</div>
              </div>
            </div>
          </div>
        </div>
        <div class="per_box2">
          <div class="per_title1 fx1">
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_circle.png"
              alt=""
            />
            <span>赢取积分秘籍</span>
          </div>
          <p>
            09月19日-09月23日2023年工博会期间，每日登录活动微站参与互动，即可获取专属积分！积分可用于每日幸运抽奖！
          </p>
          <div class="p_th_th">
            <div class="p_th_th_table">
              <div class="p_th_th_table_tr1">
                <div>互动方式</div>
                <div>获得积分</div>
                <div>获取说明</div>
              </div>
              <div class="p_th_th_table_tr_num num1">
                <div>注册会员</div>
                <div>200积分</div>
                <div class="keep-line">
                  微站内<span
                    @click="toLogin"
                    v-if="!$store.state.islogin"
                    class="login_btn"
                    v-ga="{
                      event: 'trk',
                      ec: 'pclogin',
                      ea: 'unlogtips',
                      el: 'regis',
                    }"
                    >报名注册</span
                  >
                  <span v-else class="normal_btn">报名注册</span>
                  即可获取
                </div>
              </div>
              <div class="p_th_th_table_tr_num p_th_th_table_tr_num2 num2">
                <div>每日登录</div>
                <div>50积分</div>
                <div>即日起至09月23日每日登录即可获得</div>
              </div>
              <div class="p_th_th_table_tr_num p_th_th_table_tr_num1 num1">
                <div>观看直播</div>
                <div>200积分</div>
                <div>首次进入直播间观看即可获取</div>
              </div>
              <div class="p_th_th_table_tr_num p_th_th_table_tr_num1 num2">
                <div v-html="clientWidth > 750 ? '直播小问答' : '直播<br>小问答'"></div>
                <div>50积分</div>
                <div>
                  首次答题正确即可获得50会员积分
                </div>
              </div>
              <div class="p_th_th_table_tr_num num1">
                <div>有奖调研</div>
                <div>500积分</div>
                <div>参与有奖调研即可获取</div>
              </div>
              <div class="p_th_th_table_tr_num p_th_th_table_tr2 num2">
                <div v-html="clientWidth > 750 ? '访问行业云展厅' : '访问<br>行业云展厅'" ></div>
                <div>200积分</div>
                <div>首次访问单个行业云展厅即可获取</div>
              </div>
              <div class="p_th_th_table_tr_num num1" id="table-border">
                <div v-html="clientWidth > 750 ? '新品展示小问答' : '新品展示<br>小问答'"></div>
                <div>50积分</div>
                <div>
                  首次答题正确即可获得50会员积分
                </div>
              </div>
              <div class="p_th_th_table_tr_num p_th_th_table_tr_num2 num2">
                <div>下载文档</div>
                <div>50积分</div>
                <div>首次下载文档即可获得50会员积分</div>
              </div>
            </div>
          </div>
          <div class="per_title1 fx1">
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_circle.png"
              alt=""
            />
            <span>每日幸运抽奖</span>
          </div>
          <p>
            活动期间，我们将通过施耐德电气官方公众号，向当天在微站中参与互动的会员推送抽奖通知。推荐置顶施耐德电气官方公众号，以免错失获奖机会！
          </p>
          <div class="per_title2" :class="clientWidth > 768 ? 'fx1' : ''">
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_arrow.png"
              alt=""
            />
            <span>活动时间：</span>
            <span v-if="clientWidth > 768"
              >09月19日-09月23日，每晚18:00，连续5天。</span
            >
            <p v-if="clientWidth <= 768">
              09月19日-09月23日，每晚18:00，连续5天。
            </p>
          </div>
          <div class="per_title2" :class="clientWidth > 768 ? 'fx1' : ''">
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_arrow.png"
              alt=""
            />
            <span>活动规则：</span>
            <span v-if="clientWidth > 768"
              >活动期间登录且互动的用户，每人每天可获得一次抽奖机会，次次有奖！</span
            >
            <p v-if="clientWidth <= 768">
              活动期间登录且互动的用户，每人每天可获得一次抽奖机会，次次有奖！
            </p>
          </div>
          <div class="per_title2" :class="clientWidth > 768 ? 'fx1' : ''">
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_arrow.png"
              alt=""
            />
            <span>重要提示：</span>
            <span v-if="clientWidth > 768"
              >若您抽中实物礼品，请中奖后及时在抽奖界面下方的活动锦囊处添加您的收货地址，并确保信息填写准确，我们将在活动结束后寄出奖品。</span
            >
            <p v-if="clientWidth <= 768">
              若您抽中实物礼品，请中奖后及时在抽奖界面下方的活动锦囊处添加您的收货地址，并确保信息填写准确，我们将在活动结束后寄出奖品。
            </p>
          </div>
          <div class="per_gift" v-if="clientWidth > 768">
            <div class="gift_box">
              <div class="gift" v-for="(item, index) in giftlist" :key="index + 100">
                <img :src="item.img" alt="" />
                <div class="gift_name">{{ item.title }}</div>
              </div>
            </div>
            <div class="gift_box">
              <div class="gift" v-for="(item, index) in coinlist" :key="index + 200">
                <img :src="item.img" alt="" />
                <div class="gift_name">{{ item.title }}</div>
              </div>
            </div>
          </div>
          <div class="per_gift" v-else>
            <swiper :options="swiperOption" ref="mySwiper">
              <div
                class="swiper-button-prev swiper-button1"
                slot="button-prev"
              ></div>
              <div
                class="swiper-button-next swiper-button1"
                slot="button-next"
              ></div>
              <swiper-slide v-for="ind in 2" :key="ind + 500" class="gift_box">
                <div
                  class="gift gift1"
                  v-for="(item, index) in giftlist_m.slice(ind * 2 - 2, ind * 2)"
                  :key="index + 300"
                >
                  <img :src="item.img_m" alt="" />
                  <div class="gift_name">{{ item.title }}</div>
                </div>
                <div
                  class="gift"
                  v-for="(item, index) in coinlist_m.slice(ind * 2 - 2, ind * 2)"
                  :key="index + 400"
                >
                  <img :src="item.img_m" alt="" />
                  <div class="gift_name">{{ item.title }}</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="per_title1 fx1">
            <span>活动声明：</span>
          </div>
          <div class="per_title3 fx1">
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_circle1.png"
              alt=""
            />
            <span v-if="clientWidth > 768"
              >以上全部活动时间为2023年工博会期间有效：2023年09月19日-2023年09月23日，逾期自动失效。</span
            >
            <span v-if="clientWidth <= 768"
              >&nbsp;&nbsp;&nbsp;&nbsp;以上全部活动时间为2023年工博会期间有效：2023年09月19日-2023年09月23日，逾期自动失效。</span
            >
          </div>
          <div class="per_title3" :class="clientWidth <= 768 ? 'fx1' : ''">
            <img
              :class="clientWidth > 768 ? 'per_title3_img' : ''"
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_circle1.png"
              alt=""
            />
            <span v-if="clientWidth > 768"
              >凡参与以上活动者，即视为接受活动所有规则，须遵循施耐德电气（中国）有限公司法律声明及其他关于营销活动的相关规定，且须遵循施耐德电气（中国）有限公司有权在法律允许的范围内对活动规则做出适当调整。</span
            >
            <span v-if="clientWidth <= 768"
              >&nbsp;&nbsp;&nbsp;&nbsp;凡参与以上活动者，即视为接受活动所有规则，须遵循施耐德电气（中国）有限公司法律声明及其他关于营销活动的相关规定，且须遵循施耐德电气（中国）有限公司有权在法律允许的范围内对活动规则做出适当调整。</span
            >
          </div>
          <div class="per_title3 fx1">
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_circle1.png"
              alt=""
            />
            <span v-if="clientWidth > 768"
              >通过不当途径参加以上活动的行为，一经发现我公司有权终止该客户参加本次活动并取消其获奖资格。</span
            >
            <span v-if="clientWidth <= 768"
              >&nbsp;&nbsp;&nbsp;&nbsp;通过不当途径参加以上活动的行为，一经发现我公司有权终止该客户参加本次活动并取消其获奖资格。</span
            >
          </div>
          <div class="per_title3 fx1">
            <img
              src="https://staticdn.ht-s.cn/se/ciif/2022/personal/icon_circle1.png"
              alt=""
            />
            <span v-if="clientWidth > 768">每个实物礼品只有一次获得机会。</span>
            <span v-if="clientWidth <= 768"
              >&nbsp;&nbsp;&nbsp;&nbsp;每个实物礼品只有一次获得机会。</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);

import { UserIntegralInfo } from "../../api/index.js";
import { setCookie, removeCookie } from "../../utils/_handleCookie";
import { GetUserLogs } from "@/api/index.js";
export default {
  data() {
    return {
      swiperOption: {
        direction: "horizontal",
        // loop: true,
        // slidesPerView: 1.25,
        centeredSlides: true,
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      banner: "https://staticdn.ht-s.cn/se/ciif/2023/personal/banner.png",
      banner_m: "https://staticdn.ht-s.cn/se/ciif/2023/index/banner_m.png",
      pointAll: {},
      giftlist: [
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift1.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift1_m.png",
          title: "任天堂 Switch",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift2.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift2_m.png",
          title: "华为手表",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift3.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift3_m.png",
          title: "四合一无线充手机支架",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift4.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift4_m.png",
          title: "小米蓝牙项圈耳机青春版",
        },
      ],
      coinlist: [
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin4.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin_m4.png",
          title: "1000 积分",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin3.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin_m3.png",
          title: "500 积分",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin2.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin_m2.png",
          title: "300 积分",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin1.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin_m1.png",
          title: "100 积分",
        },
      ],
      giftlist_m: [
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift1.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift1_m.png",
          title: "任天堂 Switch",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift2.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift2_m.png",
          title: "华为手表",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin4.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin_m4.png",
          title: "1000 积分",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin3.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin_m3.png",
          title: "500 积分",
        },
      ],
      coinlist_m: [
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift3.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift3_m.png",
          title: "四合一无线充手机支架",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift4.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_gift4_m.png",
          title: "小米蓝牙项圈耳机青春版",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin2.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin_m2.png",
          title: "300 积分",
        },
        {
          img: "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin1.png",
          img_m:
            "https://staticdn.ht-s.cn/se/ciif/2022/personal/img_coin_m1.png",
          title: "100 积分",
        },
      ],
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    GetUserLogs({
      visitName: "页面访问-个人中心",
      visitType: 1,
      url: window.location.href,
      track: this.$route.query.track ? this.$route.query.track : 7756,
    });
    setTimeout(() => {
      // console.log(JSON.parse(sessionStorage.getItem('params')))
      this.UserIntegralInfo();
    }, 500);
  },
  methods: {
    toExhibition() {
      var params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 3);
      this.$router.push({
        name: "Exhibition",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
    toSurvey() {
      var params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 6);
      this.$router.push({
        name: "Survey",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
    },
    goOut() {
      this.$eventBus.$emit('message', '退出登录');
      if (/(micromessenger)/i.test(navigator.userAgent)){
        setCookie("QC_Token2023", '%%')
      }else{
        removeCookie("QC_Token2023");
        removeCookie("gongBoOpenId2022");
      }
      
      this.$store.commit("islogin", false);
      let params = this.$route.query;
      this.$store.commit("activeIndex", 0);
      this.$router.push({
        path: "/Home/Index",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
        },
      });
      // location.reload();
    },
    toLogin() {
      if (!this.$store.state.islogin) {
        let params = this.$route.query;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.$router.push({
          name: "Register",
          query: {
            backlink: encodeURIComponent(window.location.href),
            track: params.track ? params.track : "",
            utm_source: params.utm_source ? params.utm_source : "",
            utm_medium: params.utm_medium ? params.utm_medium : "",
            utm_campaign: params.utm_campaign ? params.utm_campaign : "",
            utm_content: params.utm_content ? params.utm_content : "",
            se_sr: params.se_sr ? params.se_sr : "",
            se_md: params.se_md ? params.se_md : "",
            se_ct: params.se_ct ? params.se_ct : "",
          },
        });
      }
    },
    UserIntegralInfo() {
      UserIntegralInfo().then((res) => {
        if (res.Status == 1) {
          this.pointAll = res.Data;
        }
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    islogin() {
      return this.$store.state.islogin;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>